export default "__VITE_ASSET__eifw9yO2__"